var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarkComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0684 11.6165C12.0684 11.0963 12.275 10.5975 12.6428 10.2297C13.0106 9.8619 13.5094 9.65527 14.0296 9.65527H20.5669C21.0871 9.65527 21.5859 9.8619 21.9537 10.2297C22.3215 10.5975 22.5281 11.0963 22.5281 11.6165V22.0946C22.5281 22.8921 21.626 23.3563 20.9775 22.8928L17.2982 20.2647L13.619 22.8928C12.9699 23.3569 12.0684 22.8928 12.0684 22.0952V11.6165Z",
    fill: "#4D78AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkComp);
export default __webpack_public_path__ + "static/media/IconMarkComp.676a77968e599433cc79dd93750a32e4.svg";
export { ForwardRef as ReactComponent };